"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WatchFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_WatchFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.925 2.881a1 1 0 1 0-1.921-.295c-.68.19-1.251.678-1.537 1.344 1.772-.692 3.335-.307 4.121.406A2.97 2.97 0 0 1 8 4c.629 0 1.101.17 1.412.336.786-.713 2.35-1.098 4.121-.406a2.363 2.363 0 0 0-1.537-1.344 1 1 0 1 0-1.921.295c-.214.14-.404.313-.562.512a2.51 2.51 0 0 0-.165-.09A2.995 2.995 0 0 0 8 3c-.587 0-1.038.147-1.349.303-.06.03-.115.06-.164.09a2.376 2.376 0 0 0-.562-.512ZM3.5 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12.5 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.052 5.306c-1.927-1.197-3.493-.698-4.002-.198a.898.898 0 0 1-1.061.137C8.81 5.14 8.483 5 8 5s-.81.14-.989.245a.897.897 0 0 1-1.061-.137c-.51-.5-2.075-1-4.002.198L.47 9.246A3.5 3.5 0 1 0 7 10.924v-.766A3.73 3.73 0 0 1 8 10c.34 0 .693.07 1 .157V11a3.5 3.5 0 1 0 6.53-1.753l-1.478-3.94ZM6 11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm4 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_WatchFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = WatchFill;
exports["default"] = _default;